module.exports = __webpack_public_path__ + "img/selected-quick-link.1a38330f.svg";